// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"707":"21586083","818":"1d26b947","898":"e29ab2ff","933":"836b6158","961":"29d646a3"}[chunkId] + ".chunk.css";
};